import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const schedulesRoute: InvariantJiraRoute = {
	name: 'servicedesk-schedules',
	path: '/jira/servicedesk/projects/:projectKey/schedules',
	exact: true,
};
